import type { FC, MouseEventHandler } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { Button, Stack, Typography } from "@mui/material";
import { useShallowPickSelector } from "store/useSelector";
import { BottomSheet } from "components/atoms/BottomSheet";
import { appActions } from "store/app/app.slice";
import {
  useGetEditablePlaylistsQuery,
  useAddToPlaylistMutation,
} from "store/current-user/current-user.api";
import { ReactComponent as PlusSVG } from "assets/images/plus.svg";

export const AddToPlaylistMenu: FC = () => {
  const { addToPlaylistMenu } = useShallowPickSelector("app", [
    "addToPlaylistMenu",
  ]);
  const { user, auth } = useShallowPickSelector("currentUser", [
    "user",
    "auth",
  ]);

  const { data: editablePlaylists } = useGetEditablePlaylistsQuery(undefined, {
    skip: !user || !auth || !addToPlaylistMenu.isOpen,
  });
  const [addToPlaylist] = useAddToPlaylistMutation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const _location = useLocation();

  const onClose = () => {
    dispatch(
      appActions.setAddToPlaylistMenu({
        isOpen: false,
        track: addToPlaylistMenu.track,
      })
    );
  };

  const onClickOpenCreatePlaylistMenu: MouseEventHandler = () => {
    dispatch(appActions.setCreatePlaylistMenu({ isOpen: true }));
  };

  const onClickAddToPlaylist = (playlistId: string) => {
    if (user && playlistId && addToPlaylistMenu.track) {
      addToPlaylist({
        playlistId,
        body: { ids: [addToPlaylistMenu.track.id] },
      });
      onClose();
    }
  };

  return (
    <BottomSheet
      Title={
        <Stack direction={"row"} alignItems={"center"} m={3} ml={2}>
          <Button
            startIcon={<PlusSVG opacity={0.3} />}
            color={"secondary"}
            sx={{ color: "rgba(255,255,255,0.5)" }}
            onClick={onClickOpenCreatePlaylistMenu}
          >
            جدید
          </Button>
          <Typography textAlign={"right"} flex={1} fontWeight={700}>
            …افزودن به
          </Typography>
        </Stack>
      }
      isOpen={addToPlaylistMenu.isOpen}
      onClose={onClose}
      items={editablePlaylists?.map((playlist) => ({
        text: playlist.name,
        onClick: () => onClickAddToPlaylist(playlist.id),
      }))}
    />
  );
};
